<template>
    <div class="card__body m--margin-top-40">
        <div class="row">
            <div class="col-12 form-group m-form__group">
                <p class="text-center input--hint">Create your Carbon PIN</p>
                <pincode
                    type="password"
                    class_name="pincode_wrapper"
                    v-bind:input="pincodes"
                    name="pincode"
                    :multiple=true
                    v-on:onFishied="onFishied"
                    ref="newPincode"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-12 form-group m-form__group">
                <p class="text-center input--hint">Confirm your Carbon PIN</p>
                <pincode
                    type="password"
                    class_name="pincode_wrapper"
                    v-bind:input="pincodesConfrim"
                    name="pincodeConfrim"
                    :multiple=true
                    v-on:onFishied="onFishiedConfrim"
                    ref="confirmNewPincode"
                />
            </div>
        </div>
    </div>
</template>
<script>
import pincode from "./pincode";

export default {
    props: {
        callback: Function
    },
    components: {
        pincode
    },
    data: () => ({
        pincodes: ["", "", "", ""],
        pincodesConfrim: ["", "", "", ""],
    }),
    methods: {
        onFishied() {
            this.$refs.confirmNewPincode.reset()
        },
        onFishiedConfrim(callback) {
            this.callback()
        },
        resetCC() {
            this.pincodes = ["", "", "", ""];
            this.pincodesConfrim = ["", "", "", ""];
            this.$refs.newPincode.reset()
        },
        confirmPins() {
            return this.pincodes.join("").length === 4 && this.pincodes.join("") === this.pincodesConfrim.join("")
        }
    },
}
</script>
